import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Grid, Typography } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import CustomButton from '../button/custom-button/CustomButton.js';
import PropTypes__default from 'prop-types';
import { BUTTON_TYPES } from '../../common/constant.js';
import { retrieveContentfulImage } from '../../common/image.js';
import CustomRichTextFromMarkdown from '../text/CustomRichTextFromMarkdown.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty({
      padding: theme.spacing(3),
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1.5)
    }, theme.breakpoints.down("xs"), {
      marginRight: -theme.spacing(2),
      marginLeft: -theme.spacing(2),
      borderRadius: 0,
      padding: theme.spacing(2, 3),
      marginBottom: theme.spacing(2)
    }),
    img: {
      width: theme.spacing(12.5),
      height: theme.spacing(12.5)
    },
    mr2: {
      marginRight: theme.spacing(2)
    },
    descriptionText: {
      "& p": _objectSpread({}, theme.typography.body2)
    }
  };
});
var InfoBanner = function InfoBanner(_ref) {
  var bgColor = _ref.bgColor,
    subtitle = _ref.subtitle,
    title = _ref.title,
    description = _ref.description,
    imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    buttons = _ref.buttons;
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen,
    isSmallScreen = _useBreakpoints.isSmallScreen;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.root,
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center"
  }, !isExtraSmallScreen() && !isSmallScreen() && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, imageUrl && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    md: 2
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    alt: imageTitle || "",
    src: retrieveContentfulImage(imageUrl, {
      width: 100,
      height: 100
    }),
    className: classes.img
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 10
  }, subtitle && /*#__PURE__*/React__default.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, subtitle)), title && /*#__PURE__*/React__default.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4"
  }, title)), description && /*#__PURE__*/React__default.createElement(Box, {
    mb: 2,
    className: classes.descriptionText
  }, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
    markdownString: description
  })), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: isExtraSmallScreen() ? "column" : "row"
  }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (i, index) {
    var _BUTTON_TYPES$i$butto, _i$button, _BUTTON_TYPES$i$butto2, _i$button2, _i$button3, _i$button4, _i$button5, _i$button7;
    return /*#__PURE__*/React__default.createElement(Box, {
      mr: isExtraSmallScreen() ? 0 : 2,
      mb: isExtraSmallScreen() && (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 1 ? 2 : 0,
      key: index
    }, /*#__PURE__*/React__default.createElement(CustomButton, {
      variant: ((_BUTTON_TYPES$i$butto = BUTTON_TYPES[i === null || i === void 0 || (_i$button = i.button) === null || _i$button === void 0 ? void 0 : _i$button.type]) === null || _BUTTON_TYPES$i$butto === void 0 ? void 0 : _BUTTON_TYPES$i$butto.variant) || "contained",
      color: (_BUTTON_TYPES$i$butto2 = BUTTON_TYPES[i === null || i === void 0 || (_i$button2 = i.button) === null || _i$button2 === void 0 ? void 0 : _i$button2.type]) === null || _BUTTON_TYPES$i$butto2 === void 0 ? void 0 : _BUTTON_TYPES$i$butto2.color,
      href: !(i !== null && i !== void 0 && (_i$button3 = i.button) !== null && _i$button3 !== void 0 && _i$button3.openInNewTab) ? i === null || i === void 0 || (_i$button4 = i.button) === null || _i$button4 === void 0 ? void 0 : _i$button4.url : undefined,
      onClick: i !== null && i !== void 0 && (_i$button5 = i.button) !== null && _i$button5 !== void 0 && _i$button5.openInNewTab ? function () {
        var _i$button6;
        return window.open(i === null || i === void 0 || (_i$button6 = i.button) === null || _i$button6 === void 0 ? void 0 : _i$button6.url, "_blank").focus();
      } : undefined
    }, i === null || i === void 0 || (_i$button7 = i.button) === null || _i$button7 === void 0 ? void 0 : _i$button7.label));
  })))));
};
InfoBanner.propTypes = {
  bgColor: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  title: PropTypes__default.string,
  description: PropTypes__default.string,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  buttons: PropTypes__default.array
};

export { InfoBanner as default };
//# sourceMappingURL=InfoBanner.js.map
